import { Card } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setShowHelpModal, setShowSettingsModal } from "../../store/slices/appSlice";

function HelpModal(props: any) {
    const { t } = useTranslation(["texts", "errors"]);
    const dispatch = useAppDispatch();
    const showHelpModal = useAppSelector((state) => state.app.showHelpModal);

    const toggleHelpModal = () => {
        if (showHelpModal)
            dispatch(setShowSettingsModal(true));
        dispatch(setShowHelpModal(!showHelpModal));
    }

    return (
        <Modal isOpen={showHelpModal} toggle={toggleHelpModal } size="m" className="help-modal">
            <ModalHeader toggle={toggleHelpModal }>
                <Row>
                    <Col><img width="60" src="./img/ProAgria_logo.png" alt="MobiLink" /></Col>
                </Row>
                <Row>
                    <Col>{t("Help.Title")}</Col>
                </Row>
            </ModalHeader>
            <ModalBody>
                <Card>
                    <h6>{t("Help.GeneralTitle")}</h6>
                    {t("Help.General") }
                </Card>
                <Card>
                    <h6>{t("Help.CameraTitle")}</h6>
                    {t("Help.Camera")}
                </Card>
                <Card>
                    <h6>{t("Help.MilkExtraAnalysisTitle")}</h6>
                    {t("Help.MilkExtraAnalysis")}
                </Card>
                <Card>
                    <h6>{t("Help.SendTitle")}</h6>
                    {t("Help.Send")}
                </Card>
                <Card>
                    <h6>{t("Help.SearchTitle")}</h6>
                    {t("Help.Search")}
                </Card>
                <Card>
                    <h6>{t("Help.ChangeHerdTitle")}</h6>
                    {t("Help.ChangeHerd")}
                </Card>
                <Card>
                    <h6>{t("Help.OrderByTitle")}</h6>
                    {t("Help.OrderBy")}
                </Card>
                <Card>
                    <h6>{t("Help.BarcodesSendToTitle")}</h6>
                    {t("Help.BarcodesSendTo")}
                </Card>
            </ModalBody>
        </Modal>
    );
}

export default HelpModal;